import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, Router } from '@angular/router';

import { filter } from 'rxjs';

import { LoadingService } from './services/loading.service';

@Component({
    selector: 'oc-bms-client-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
    title = 'bms-client';

    constructor(private readonly router: Router, private readonly destroyRef: DestroyRef, private readonly loadingService: LoadingService) {
        this.router.events
            .pipe(
                filter((e): e is NavigationEnd => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe(() => loadingService.hide());
    }
}
